<template>
  <div class="app-logo">
    <img
      src="./logo.png"
      alt=""
    >
    <p class="subtitle">
      本服务由上海松鼠云上人工智能技术有限公司提供
    </p>
  </div>
</template>
<script>
/* eslint-disable */
export default {

};
</script>
<style lang="scss">
.app-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  flex-direction: column;
  img {
    width: 156px;
  }
  .subtitle {
    color: rgba(0, 0, 0, 0.3);
    font-size: 20px;
    text-align: center;
    margin-top: 20px;
  }
}
</style>
